import { TemplateEditViews } from '../common/types';
import { useQueryParamContext } from '../context/QueryParamContext';
import { WebPushContext } from './context/WebPushContext';
import PreviewWithData from './PreviewWithData';
import Settings from './Settings';

const renderView = (view: string) => {
  switch (view) {
    case TemplateEditViews.preview:
      return <PreviewWithData />;
    default:
      return <Settings />;
  }
};

export const EditWebPush = () => {
  const { view } = useQueryParamContext();

  return <WebPushContext>{renderView(view)}</WebPushContext>;
};

export default EditWebPush;
